enum PermissionEnum {
  None = "None",
  Read = "Read",
  Write = "Write",
  ReadWrite = "ReadWrite",
}

export default PermissionEnum;
